import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close-circle.svg'
import _imports_1 from '../assets/edit.svg'
import _imports_2 from '../assets/code.svg'
import _imports_3 from '../../globalModule/assets/save.svg'
import _imports_4 from '../assets/new-node.svg'
import _imports_5 from '../assets/topic.svg'
import _imports_6 from '../assets/service.svg'


const _withScopeId = n => (_pushScopeId("data-v-f9be4702"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "heading-div" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading-text" }, "Nodes Canvas", -1))
const _hoisted_9 = { class: "save-text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  height: "25",
  alt: "code view",
  src: _imports_2
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "row-div" }
const _hoisted_15 = {
  class: "side-column",
  id: "sideColumn",
  ref: "sideColumn"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "New Elements", -1))
const _hoisted_17 = { class: "canvas-button" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "edit-img-icon",
  src: _imports_4
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "canvas-button" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "edit-img-icon",
  src: _imports_5
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "canvas-button" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "edit-img-icon",
  src: _imports_6
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "canvas-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActiveMessages = _resolveComponent("ActiveMessages")!
  const _component_EditTopicBox = _resolveComponent("EditTopicBox")!
  const _component_EditNodeBox = _resolveComponent("EditNodeBox")!
  const _component_NodeParams = _resolveComponent("NodeParams")!
  const _component_AddTopicConnectionPrompt = _resolveComponent("AddTopicConnectionPrompt")!
  const _component_ServiceConnectionPromt = _resolveComponent("ServiceConnectionPromt")!
  const _component_EditServiceBox = _resolveComponent("EditServiceBox")!
  const _component_AddNewMsgType = _resolveComponent("AddNewMsgType")!
  const _component_PullCodes = _resolveComponent("PullCodes")!
  const _component_MountedExecute = _resolveComponent("MountedExecute")!

  return (!_ctx.db.isSet)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "...loading"))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "icon-button",
            title: "Exit nodes canvas",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exitNodesCanvas()))
          }, _hoisted_5),
          _createElementVNode("button", {
            class: "icon-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editClicked()))
          }, _hoisted_7),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.saveText), 1),
          _createElementVNode("button", {
            class: "icon-button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push(`/codeView/${_ctx.$route.params.workspaceID}`)))
          }, _hoisted_11),
          _createElementVNode("button", {
            class: "icon-button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveCanvas()))
          }, _hoisted_13)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                onTouchstart: _cache[4] || (_cache[4] = (e) => _ctx.touchStart(e)),
                onTouchend: _cache[5] || (_cache[5] = (e) => _ctx.editDragEnd(e, 'node')),
                onDragend: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editDragEnd($event, 'node'))),
                onDblclick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.spawnCanvasObjectRandomLocation('node'))),
                class: "icon-button"
              }, _hoisted_19, 32),
              _createTextVNode(" Node ")
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                onTouchstart: _cache[8] || (_cache[8] = (e) => _ctx.touchStart(e)),
                onTouchend: _cache[9] || (_cache[9] = (e) => _ctx.editDragEnd(e, 'topic')),
                onDragend: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editDragEnd($event, 'topic'))),
                onDblclick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.spawnCanvasObjectRandomLocation('topic'))),
                class: "icon-button"
              }, _hoisted_22, 32),
              _createTextVNode(" Topic ")
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                onTouchstart: _cache[12] || (_cache[12] = (e) => _ctx.touchStart(e)),
                onTouchend: _cache[13] || (_cache[13] = (e) => _ctx.editDragEnd(e, 'service')),
                onDragend: _cache[14] || (_cache[14] = ($event: any) => (_ctx.editDragEnd($event, 'service'))),
                onDblclick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.spawnCanvasObjectRandomLocation('service'))),
                class: "icon-button"
              }, _hoisted_25, 32),
              _createTextVNode(" Service ")
            ])
          ], 512), [
            [_vShow, _ctx.editing]
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("canvas", {
              onMouseup: _cache[16] || (_cache[16] = (e) => _ctx.mouseUp(e)),
              id: "node-canvas",
              ref: "node-canvas",
              class: "canvas",
              droppable: true
            }, null, 544)
          ])
        ]),
        _createVNode(_component_ActiveMessages, {
          externalPackages: 
        _ctx.globalStore.packages.filter((pkg) => pkg.id !== _ctx.$route.params.packageID)
      ,
          onMouseUp: _ctx.externalMessageMouseup,
          isHovering: _ctx.connectingNode !== null
        }, null, 8, ["externalPackages", "onMouseUp", "isHovering"]),
        _createVNode(_component_EditTopicBox, { active: _ctx.editingTopic }, null, 8, ["active"]),
        _createVNode(_component_EditNodeBox, {
          onOnShowEditParams: _cache[17] || (_cache[17] = () => _ctx.toggleIsShowParams(true)),
          active: _ctx.editingNode
        }, null, 8, ["active"]),
        _createVNode(_component_NodeParams, {
          onOnExit: _cache[18] || (_cache[18] = () => _ctx.toggleIsShowParams(false)),
          isShowParams: _ctx.isShowParams
        }, null, 8, ["isShowParams"]),
        _createVNode(_component_AddTopicConnectionPrompt, {
          active: 
        _ctx.ncStore.connectingTopicNode !== undefined &&
        _ctx.ncStore.connectingTopicNode !== null
      
        }, null, 8, ["active"]),
        _createVNode(_component_ServiceConnectionPromt),
        _createVNode(_component_EditServiceBox, {
          onEditServiceEnd: _cache[19] || (_cache[19] = () => _ctx.stage.dispatchEvent('editServiceEnd'))
        }),
        _createVNode(_component_AddNewMsgType),
        _createVNode(_component_PullCodes, {
          onBuildLocal: _cache[20] || (_cache[20] = ($event: any) => (_ctx.generateCode()))
        }),
        _createVNode(_component_MountedExecute, {
          onNowMounted: _cache[21] || (_cache[21] = () => _ctx.reMount())
        })
      ]))
}